/* ---------- SHE Pack Fill In component ------------------

    -   This component is used for when the user is completing a checklist. 
*/

// ------------------ React Components ------------------------
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// -------------------- API -----------------------------
import API_BASE_URL from "../../utils/api/apiConfig.js";


// --------------------- CSS File --------------------
import '../../../assets/css/Checklists.css';

// --------------------- icons --------------------

import { LiaSpinnerSolid } from "react-icons/lia";



import { FaRegFolderOpen } from "react-icons/fa";

// --------------------- Assests -------------------
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';


import ToasterViewTemplateComplianceSubmissions from './ToasterViewTemplateComplianceSubmissions.js';


// --------------------- View SHE Pack component -------------------
const ViewTemplateSubmissionComplianceComponent = () => {

  

  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null);

  // Retrieve user data from session storage
  const user = JSON.parse(sessionStorage.getItem('user'));

  const navigate = useNavigate();

  /*------------------------------------------------------------------------
                              State Management
  --------------------------------------------------------------------------*/

  // ---------------------- State Management - Filters ------------------ 
  const [filterCompany, setFilterCompany] = useState('');
  const [filterSite, setFilterSite] = useState('');
  const [filterSheFile, setFilterSheFile] = useState('');
  const [filterSheUser, setFilterSheUser] = useState('');

  const [uniqueCompanies, setUniqueCompanies] = useState([]);
const [uniqueSites, setUniqueSites] = useState([]);
const [uniqueSheFiles, setUniqueSheFiles] = useState([]);
const [uniqueSheUsers, setUniqueSheUsers] = useState([]);


  const [newSubmissionErrors, setNewSubmissionErrors] = useState({});

  // ----------------- SUbmissions ---------------
  // Add new state for existing submissions
const [newSubmissions, setNewSubmissions] = useState([]);
const [existingSubmissions, setExistingSubmissions] = useState([]);

  // New state for companies and departments
  const [sheFileCompanies, setSheFileCompanies] = useState({});
  const [selectedCompanies, setSelectedCompanies] = useState({});
  const [selectedCompanyName, setSelectedCompanyName] = useState({});

  
  const [departmentsPerCompany, setDepartmentsPerCompany] = useState({});
  const [selectedDepartments, setSelectedDepartments] = useState({});
  const [selectedDepartmentName, setSelectedDepartmentName] = useState({});

  

  // State Management - Global 
  const [submissionStatus, setSubmissionStatus] = useState('Not Started');

  

  // State Management - selected she pack
  const [selectedSheFileId, setSelectedSheFileId] = useState(null);
  const [selectedSheFileName, setSelectedSheFileName] = useState('');

  const [selectedSheFileUserScore, setSelectedSheFileUserScore] = useState(null);
  const [currentUserScore, setCurrentUserScore] = useState(selectedSheFileUserScore);
  const [selectedSheFileScore, setSelectedSheFileScore] = useState(null);

  const [templates, setTemplates] = useState([]);
  const [templateResponses, setTemplateResponses] = useState([]);
  

  // state management - slected document 
  // Add these state variables near your other state declarations
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState('');
  const [selectedTemplateScore, setSelectedTemplateScore] = useState('');
  const [selectedTemplateUserPercentage, setSelectedTemplateUserPercentage] = useState('');


  //
  const [assignedSheFiles, setAssignedSheFiles] = useState([]);

  
  //
  const [showTemplateToaster, setShowTemplateToaster] = useState(false);

 
  const [isLoading, setIsLoading] = useState(true);

  /*----------------------------------------------------------------
                              Use Effects 
  -------------------------------------------------------------------*/

  // Use Effects - 
  useEffect(() => {
    // Only use newSubmissions (remove existingSubmissions)
    if (newSubmissions && newSubmissions.length > 0) {
      // Extract unique companies
      const companies = [...new Set(newSubmissions.map(item => item.company_name))].sort();
      setUniqueCompanies(companies);
      
      // Extract unique sites
      const sites = [...new Set(newSubmissions.map(item => item.department_name))].sort();
      setUniqueSites(sites);
      
      // Extract unique SHE files
      const sheFiles = [...new Set(newSubmissions.map(item => item.shefile_name))].sort();
      setUniqueSheFiles(sheFiles);
      
      // Extract unique SHE users
      const sheUsers = [...new Set(newSubmissions.map(item => item.consultant_name || item.user_name))].filter(Boolean).sort();
      setUniqueSheUsers(sheUsers);
    }
  }, [newSubmissions]);



  // -------------------------- Use Effects - Fetch Submissions -------------
  useEffect(() => {
    const fetchSubmissions = async () => {
      setIsLoading(true);
      
      try {

        // Only fetch new submissions
        const newResponse = await axios.get(`${API_BASE_URL}/api/compliance-tracker/file-and-template-viewer/view-template-submissions`);
        setNewSubmissions(newResponse.data);

      
        for (const shefile of newResponse.data) {
          const companiesResponse = await axios.get(
            `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/consultant-assignments/company/${shefile.shefile_id}/${user.user_id}`
          );
          
          setSheFileCompanies(prev => ({
            ...prev,
            [shefile.shefile_id]: companiesResponse.data
          }));

          const departmentsMap = {};
          companiesResponse.data.forEach(companyData => {
            departmentsMap[companyData.company] = companyData.departments;
          });
          
          setDepartmentsPerCompany(prev => ({
            ...prev,
            [shefile.shefile_id]: departmentsMap
          }));
        }

      } catch (error) {
        console.error('Error fetching submissions:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubmissions();
  }, [user.user_id]);
  
  

  /*------------------------------------------------------------------
                          Functions
  *-------------------------------------------------------------------*/

  // Filter the submissions based on filter criteria
  const filteredSubmissions = newSubmissions.filter(sheFile => {
  // If no filters are selected, show all submissions
  if (!filterCompany && !filterSite && !filterSheFile && !filterSheUser) {
    return false; // Changed from false to true to show all when no filters applied
  }

  const matchesCompany = !filterCompany || sheFile.company_name === filterCompany;
  const matchesSite = !filterSite || sheFile.department_name === filterSite;
  const matchesSheFile = !filterSheFile || sheFile.shefile_name === filterSheFile;
  const matchesSheUser = !filterSheUser || sheFile.consultant_name === filterSheUser || sheFile.user_name === filterSheUser;
  
  return matchesCompany && matchesSite && matchesSheFile && matchesSheUser;
});


  // -------------- Functions - Filters --------------------------------
  const resetFilters = () => {
    setFilterCompany('');
    setFilterSite('');
    setFilterSheFile('');
    setFilterSheUser('');
  };



 

  
  
  // Fucntions - Global
  const handleNavigateBack = () => {
    navigate(-1);
  };


  // Update the handleClick function to include company and department

  // Add this function in ConsultantTempateFillInComponent
  // Updated refreshAssignedSheFiles function
  const refreshAssignedSheFiles = async () => {
    setIsLoading(true);
      
    try {
      // If we have a selected SHE file with company and department, refresh it specifically
      if (selectedSheFileId && selectedCompanies[selectedSheFileId] && selectedDepartments[selectedSheFileId]) {
        const companyId = selectedCompanies[selectedSheFileId];
        const departmentId = selectedDepartments[selectedSheFileId];
        
        const response = await axios.get(
          `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
        );
        
        const processedSheFiles = response.data.map(shefile => ({
          ...shefile,
          total_submissions: shefile.total_submissions 
            ? parseInt(shefile.total_submissions, 10) 
            : 0
        }));
        
        // Update the assignedSheFiles state by replacing the updated file
        setAssignedSheFiles(prev => 
          prev.map(file => {
            const updatedFile = processedSheFiles.find(updated => updated.shefile_id === file.shefile_id);
            return updatedFile || file;
          })
        );
        
        // Update the selected SHE file score
        const updatedSheFile = processedSheFiles.find(file => file.shefile_id === selectedSheFileId);
        if (updatedSheFile) {
          setSelectedSheFileUserScore(updatedSheFile.user_score);
          setSelectedSheFileScore(updatedSheFile.shefile_score);
        }
      } 
      
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setIsLoading(false);
    }
};

  //
  const refreshTemplates = async () => {
  // Only proceed if we have the required data
  if (!selectedSheFileId || !selectedCompanies[selectedSheFileId] || !selectedDepartments[selectedSheFileId]) {
    console.error('Missing required data for template refresh');
    return;
  }

  // Check if we have a submissionId - this is key for QA review context
  if (!selectedSubmissionId) {
    console.error('Missing submissionId for template refresh');
    return;
  }

  setIsLoading(true);

  try {
    const companyId = selectedCompanies[selectedSheFileId];
    const departmentId = selectedDepartments[selectedSheFileId];

    console.log('Refreshing templates for:', {
      sheFileId: selectedSheFileId,
      companyId,
      departmentId,
      submissionId: selectedSubmissionId
    });

    // Fetch updated SHE file data with specific company and department
    const updatedSheFileResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
    );

    // Update the user score with the specific company/department data
    const specificSheFile = updatedSheFileResponse.data.find(file => file.shefile_id === selectedSheFileId);
    if (specificSheFile) {
      setSelectedSheFileUserScore(specificSheFile.user_score);
    }

    // Fetch templates only
    const templatesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-assigned-templates/${selectedSheFileId}/${companyId}/${departmentId}`
    );

    // Fetch template responses with submission_id parameter - THIS IS THE KEY CHANGE
    const templateResponsesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-template-responses/${user.user_id}/${selectedSheFileId}/${companyId}/${departmentId}?submission_id=${selectedSubmissionId}`
    );

    console.log('Templates Refresh API Response:', templatesResponse.data);
    console.log('Template Responses Refresh API Response:', templateResponsesResponse.data);

    if (templatesResponse.status === 200 && templateResponsesResponse.status === 200) {
      if (Array.isArray(templatesResponse.data)) {
        const templates = templatesResponse.data;
        const templateResponses = templateResponsesResponse.data;
        
        // Merge templates with their responses
        const mergedTemplates = templates.map(template => {
          // Find corresponding response for this template AND submission
          const response = templateResponses.find(resp => 
            resp.template_id === template.template_id &&
            resp.shefile_id === template.shefile_id &&
            resp.submission_id === selectedSubmissionId // Add this condition to match specific submission
          );
          
          // Merge template with response data
          return {
            ...template,

            // Template
            template_response_id: response?.template_response_id,
            template_id: template.template_id,
            template_name: template.template_name,
            template_reference: template.template_reference,
            template_score: template.template_score,
            template_frequency: template.template_frequency,
            submission_type: template.submission_type,
            
            // Template Responses
            compliance_template_submission_id: response?.compliance_template_submission_id,
            template_submission_status: response?.template_submission_status,
            user_template_score: response?.user_template_score,
            user_template_percentage: response?.user_template_percentage,
            period: response?.period,
            period_expiry_date: response?.period_expiry_date,
            qa_status: response?.qa_status,
            qa_comment: response?.qa_comment,
            submission_id: selectedSubmissionId // Use the actual submissionId from state
          };
        });
        
        setTemplates(mergedTemplates);
        setTemplateResponses(templateResponses);
      }
    }

  } catch (error) {
    console.error('Error refreshing templates:', error);
  } finally {
    setIsLoading(false);
  }
};

// Fixed handleQaViewConsultantSubmission function
const handleViewConsultantSubmission = async (sheFileId, sheFileName, sheFileUserScore, sheFileScore, submissionId) => {
  setIsLoading(true);
  setSelectedSheFileId(sheFileId);
  setSelectedSheFileName(sheFileName);
  setSelectedSheFileUserScore(sheFileUserScore);
  setSelectedSheFileScore(sheFileScore);
  setSelectedSubmissionId(submissionId);

  // First, try to find the submission in newSubmissions (Pending QA)
  let sheFile = newSubmissions.find(file => 
    file.shefile_id === sheFileId && file.submission_id === submissionId
  );

  // If not found in newSubmissions, try existingSubmissions (Rejected QA)
  if (!sheFile) {
    sheFile = existingSubmissions.find(file => 
      file.shefile_id === sheFileId && file.submission_id === submissionId
    );
  }

  // If still not found, log error and return
  if (!sheFile) {
    console.error('SHE File not found for submission:', submissionId);
    console.error('Searched in newSubmissions:', newSubmissions);
    console.error('Searched in existingSubmissions:', existingSubmissions);
    setIsLoading(false);
    return;
  }

  try {
    const companyId = sheFile.company;
    const departmentId = sheFile.department;

    // Use submission_id as part of the state key to differentiate between submissions
    const stateKey = `${sheFileId}_${submissionId}`;

    // Save to selectedCompanies and selectedDepartments states with unique keys
    setSelectedCompanies(prev => ({ ...prev, [stateKey]: companyId }));
    setSelectedCompanyName(prev => ({ ...prev, [stateKey]: sheFile.company_name }));
    setSelectedDepartments(prev => ({ ...prev, [stateKey]: departmentId }));
    setSelectedDepartmentName(prev => ({ ...prev, [stateKey]: sheFile.department_name }));

    // Also set the current selection for the toaster (using original sheFileId for backward compatibility)
    setSelectedCompanies(prev => ({ ...prev, [sheFileId]: companyId }));
    setSelectedCompanyName(prev => ({ ...prev, [sheFileId]: sheFile.company_name }));
    setSelectedDepartments(prev => ({ ...prev, [sheFileId]: departmentId }));
    setSelectedDepartmentName(prev => ({ ...prev, [sheFileId]: sheFile.department_name }));

    const updatedSheFileResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
    );

    const specificSheFile = updatedSheFileResponse.data.find(file => file.shefile_id === sheFileId);
    if (specificSheFile) {
      setSelectedSheFileUserScore(specificSheFile.user_score);
    }

    // Fetch templates with submission_id in the API call
    const templatesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-assigned-templates/${sheFileId}/${companyId}/${departmentId}`
    );

    // Fetch template responses with submission_id parameter
    const templateResponsesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-template-responses/${user.user_id}/${sheFileId}/${companyId}/${departmentId}?submission_id=${submissionId}`
    );

    if (templatesResponse.status === 200 && templateResponsesResponse.status === 200) {
      const mergedTemplates = templatesResponse.data.map(template => {
        const response = templateResponsesResponse.data.find(resp =>
          resp.template_id === template.template_id && 
          resp.shefile_id === template.shefile_id &&
          resp.submission_id === submissionId // Add this condition
        );

        return {
          ...template,
          template_id: template.template_id,
          template_name: template.template_name,
          template_reference: template.template_reference,
          template_score: template.template_score,
          template_frequency: template.template_frequency,

          submission_type: template.submission_type,

          compliance_template_submission_id: response?.compliance_template_submission_id,
          template_submission_status: response?.template_submission_status,
          template_response_id : response?.template_response_id,
          user_template_score: response?.user_template_score,
          user_template_percentage: response?.user_template_percentage,
          period: response?.period,
          period_expiry_date: response?.period_expiry_date,
          qa_status: response?.qa_status,
          qa_comment: response?.qa_comment,
          submission_id: submissionId // Add this to track which submission this belongs to
        };
      });

      setTemplates(mergedTemplates);
      setTemplateResponses(templateResponsesResponse.data);
      setShowTemplateToaster(true);
    }
  } catch (error) {
    console.error('Error fetching submission data:', error);
  } finally {
    setIsLoading(false);
  }
};


  // Function - Submissions 
  
  return (
    <div >
      <div className="create-checklist-component-container">

        <div className="create-company-text-container">

          <div>
      
            <h2>Compliance Tracker - <span className="secondary-color-paragraph">View Template Submissions</span></h2>
                
            <p>View the status, scores, and details of template submissions, including uploaded documents.</p>
              
          </div>

          <div>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="side-menu-logo" />
          </div>
          
        </div>

        <div className="navigate-back-button-main-container">
          <div className="navigate-back-button-container">
            <button className="navigate-back-button" onClick={handleNavigateBack}>Back</button>
          </div>
        </div>

        {/* New Submissions Table */}
        <div className="view-checklist-table-container">
          {isLoading ? (
            <div className="loading-spinner-container">
              <LiaSpinnerSolid className="lia-spin-solid-icon" />
            </div>
          ) : (
            <div className="view-checklist-table-table-container">

              <div>
                  <h3>Section A - <span className="secondary-color-paragraph"> Template Submissions </span></h3>
                  <p>Below are the consultants submissions. </p>
              </div>

              <div>
                <div>
                  <h3>Filter</h3>
                  <p>Use this filter to refine your search criteria.</p>
                </div>

                <div className='consultant-template-fill-in-filters-main-container'>
                  <div className='consultant-template-fill-in-filters-container'>
                    
                    {/* Filter Company */}
    <div>
      <div>
        <p>By Company Name : </p>
      </div>
      <div>
        <select 
          value={filterCompany} 
          onChange={(e) => setFilterCompany(e.target.value)}
          disabled={filterSite || filterSheFile || filterSheUser}
        >
          <option value="">-- Select Company --</option>
          {uniqueCompanies.map((company, index) => (
            <option key={index} value={company}>{company}</option>
          ))}
        </select>
      </div>
    </div>

    {/* Filter - Site */}
    <div>
      <div>
        <p>By Site : </p>
      </div>
      <div>
        <select 
          value={filterSite} 
          onChange={(e) => setFilterSite(e.target.value)}
          disabled={filterCompany || filterSheFile || filterSheUser}
        >
          <option value="">-- Select Site --</option>
          {uniqueSites.map((site, index) => (
            <option key={index} value={site}>{site}</option>
          ))}
        </select>
      </div>
    </div>

    {/* Filter - SHE File */}
    <div>
      <div>
        <p>SHE File : </p>
      </div>
      <div>
        <select 
          value={filterSheFile} 
          onChange={(e) => setFilterSheFile(e.target.value)}
          disabled={filterCompany || filterSite || filterSheUser}
        >
          <option value="">-- Select SHE Files --</option>
          {uniqueSheFiles.map((sheFile, index) => (
            <option key={index} value={sheFile}>{sheFile}</option>
          ))}
        </select>
      </div>
    </div>

    {/* Filter - User */}
    <div>
      <div>
        <p>SHE User : </p>
      </div>
      <div>
        <select 
          value={filterSheUser} 
          onChange={(e) => setFilterSheUser(e.target.value)}
          disabled={filterCompany || filterSite || filterSheFile}
        >
          <option value="">-- Select SHE User --</option>
          {uniqueSheUsers.map((user, index) => (
            <option key={index} value={user}>{user}</option>
          ))}
        </select>
      </div>
    </div>

    {/* Reset Button */}
    <div>
      <button 
        onClick={resetFilters}
        className="cancel-button"
      >
        Reset Filters
      </button>
    </div>
    
  
                    
                  </div>
                </div>
              </div>

              <table className="view-checklist-table">

                <colgroup>

                  {/* Remove whitespace between col elements */}
                  <col style={{width: "30px"}}/>{/* Select SHE Pack */}
                  <col style={{width: "200px"}}/>{/* Company */} 
                  <col style={{width: "200px"}}/>{/* Department */} 
                  <col style={{width: "300px"}}/>{/* Select SHE Pack */}
                  <col style={{width: "200px"}}/>{/* SHE Pack Name */}
                  <col style={{width: "200px"}}/>{/* SHE Pack Score */}        
                  <col style={{width: "200px"}}/>{/* SHE Pack Score */} 
                  <col style={{width: "200px"}}/>{/* SHE Pack Score */} 
                  <col style={{width: "200px"}}/>{/* Department */} 
                       
                </colgroup>

                <thead>
                  <tr>
                    <th className="table-header"> # </th>
                    <th className="table-header">Company</th>
                    <th className="table-header">Site</th>
                    <th className="table-header">SHE File Name</th>
                    <th className="table-header">Submission Id</th>
                    <th className="table-header">Submission Status</th>
                    <th className="table-header">QA Status</th>
                    <th className="table-header">Submitted by</th>
                    <th className="table-header">Select SHE File</th>
                    
                  </tr>
                </thead>

                <tbody className="view-table-body">
                  {filteredSubmissions && filteredSubmissions.length === 0 ? ( 
                    <tr>
                      <td colSpan="8">
                        <i>{newSubmissions.length === 0 ? 
                          'Please select filters' : 
                          'No submissions match your filter criteria, please select filter your selections.'
                        }</i>
                      </td>
                    </tr>
                  ) : (
                    filteredSubmissions.map((sheFile, index) => (
                      <tr key={index}>
                        {/* Your existing table row content remains the same */}
                        <td>{index + 1}</td>
                        <td>{sheFile.company_name}</td>
                        <td>{sheFile.department_name}</td>
                        <td>
                          {sheFile.shefile_name}
                          {newSubmissionErrors[sheFile.shefile_id] && (
                            <div className="error-text-main-container" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                              {newSubmissionErrors[sheFile.shefile_id]} 
                            </div>
                          )}
                        </td>
                        <td>{sheFile.submission_id || '-'}</td>
                        <td>{sheFile.submission_status || 'No Submissions'}</td>
                        <td>{sheFile.qa_status || "-"}</td>
                        <td>{sheFile.filled_in_by || "-"}</td>
                        <td>
                          {sheFile.submission_status === "Completed" ? (
                            <div className="disabled-icon-container" title="Submission is already completed">
                              <FaRegFolderOpen className='view-checklist-submition-icon disabled' style={{ cursor: 'not-allowed' }} />
                            </div>
                          ) : (
                            <div onClick={() => handleViewConsultantSubmission (
                              sheFile.shefile_id, 
                              sheFile.shefile_name, 
                              sheFile.user_score, 
                              sheFile.shefile_score,
                              sheFile.submission_id
                            )}>
                              <FaRegFolderOpen className='view-checklist-submition-icon' />
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        

      
      </div>

     

        <ToasterViewTemplateComplianceSubmissions
        
          isOpen={showTemplateToaster}
          onClose={() => navigate('/compliance-tracker/compliance-tracker-management')}

          selectedSubmissionId={selectedSubmissionId}

          selectedSheFileName={selectedSheFileName}
          selectedSheFileId={selectedSheFileId}
          selectedSheFileScore={selectedSheFileScore}
          selectedSheFileUserScore={selectedSheFileUserScore}
          
          templates={templates}
          isLoading={isLoading}
    
          // Company and Departments
          selectedCompany={selectedCompanies[selectedSheFileId]} // Pass specific company
          selectedCompanyName={selectedCompanyName[selectedSheFileId]} 
          
          selectedDepartmentName={selectedDepartmentName[selectedSheFileId]} 
          selectedDepartment={selectedDepartments[selectedSheFileId]} // Pass specific department

          templateId={selectedTemplateId}      // She Pack Document Id
          templateName={selectedTemplateName}   // SHe Pack Document Name
          templateScore={selectedTemplateScore} // She Pack Document score
          templateUserPercentage={selectedTemplateUserPercentage}
          
          submissionStatus={submissionStatus}

          //
          onSave={refreshAssignedSheFiles}
          onRefreshTemplates={refreshTemplates}  // Add this new prop
          
        />


        

      

      

     
     
      
        
      


    </div>
  );
};

export default ViewTemplateSubmissionComplianceComponent;